import React, { Fragment, useState, useEffect, useContext } from "react";
import axios from "axios";
import Dropdowns from "./Dropdowns";
import Searchresult from "./Searchresult";
import { useHistory, useLocation } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { ramactions } from "../store/index";
import SearchPageHeader from "./SearchPageHeader";
import useCustomquesrystring from "../hooks/use-querystring";
import { useTranslation } from "react-i18next";
const Supporttype = (props) => {
  const { t } = useTranslation("translation", { keyPrefix: "supportType" });
  const history = useHistory();
  const location = useLocation();
  const dispatch = useDispatch();
  const webLanguage = localStorage.getItem("lang");
  //console.log(useHistory());
  const place = useSelector((index) => index.place);
  const isPogress = useSelector((index) => index.isPogress);
  const [categorydropdown, setCategorydropdown] = useState([]);
  const [subcategorydropdown, setSubcategorydropdown] = useState([]);
  const [displaysearchresult, setDisplaysearchresult] = useState(false);
  const [searchresults, setSearchresults] = useState([]);
  const [topcategoryID, setTopcategoryID] = useState(0);
  const [subcategoryID, setSubcategoryID] = useState(0);
  const [ReadMoreTopic, setReadMoreTopic] = useState(0);
  const [languagesOfferedDropdown, setLanguagesOfferedDropdown] = useState([]);
  const [targetPopulationDropdown, setTargetPopulationDropdown] = useState([]);
  const [disabilitiesAccessDropdown, setDisabilitiesAccessDropdown] = useState(
    []
  );
  const queryParams = new URLSearchParams(location.search);
  const [feeStructureDropdown, setFeeStructureDropdown] = useState([]);
  const isDisplayresult = useSelector((index) => index.isDisplayresult);
  const subCategoryId = useSelector((index) => index.subCategoryId);
  const categoryId = useSelector((index) => index.categoryId);
  const customquery = useCustomquesrystring();
  const isApicallneeded = useSelector((index) => index.isApicallneeded);
  const [isClearClick, setIsClearClick] = useState(false);
  useEffect(async () => {
    getCategory();
    if (subCategoryId > 0 && categoryId > 0) {
      await populateSubcategory(categoryId);
      await populateDropdownData(subCategoryId);
      await diplayServices();
    }
    else if(categoryId > 0)
    {
      await populateSubcategory(categoryId);
      document.querySelector('.search_input input[type="text"]').focus();
    }
  }, []);
  const getCategory = async () => {
    try {
      const response = await axios.get(
        process.env.REACT_APP_REACT_APP_API_END_POINT +
        process.env.REACT_APP_GET_CATEGORY +
        webLanguage +
        "?code=" +
        process.env.REACT_APP_API_KEY
      );
      const topcatdata = response.data.sort(function (a, b) {
        return a.TopCategory > b.TopCategory ? 1 : -1;
      });
      setCategorydropdown(topcatdata);
      //console.log(topcatdata);
      if (parseInt(categoryId) > 0) {
        const selectedTopCategory = topcatdata.filter(
          (index) => index.TopCategoryID === categoryId
        );
        dispatch(
          ramactions.updateCategoryName(selectedTopCategory[0].TopCategory)
        );
        //console.log(selectedTopCategory[0].TopCategory);
      }
      //return response.data;
    } catch (err) {
      console.log(err);
      dispatch(ramactions.updateErrormsg(err));
      dispatch(ramactions.updateErrorstatus(1));
    }
  };

  const topcategoryHanddler = async (e) => {
    if (queryParams.has("resourceType")) {
      queryParams.delete("resourceType");
    }
    if (queryParams.has("languages")) {
      queryParams.delete("languages");
    }
    if (queryParams.has("communities")) {
      queryParams.delete("communities");
    }
    if (queryParams.has("accessibilities")) {
      queryParams.delete("accessibilities");
    }
    if (queryParams.has("costs")) {
      queryParams.delete("costs");
    }
    const elementIndex = e.nativeEvent.target.selectedIndex;
    dispatch(
      ramactions.updateCategoryName(e.nativeEvent.target[elementIndex].text)
    );
    await populateSubcategory(e.target.value);
    if(e.target.value == 17 || e.target.value == 18)
    {
      setReadMoreTopic(1)
    }
    else{
      setReadMoreTopic(0)
    }
    if (e.target.value) e.target.parentElement.classList.remove("unselected");
    else e.target.parentElement.classList.add("unselected");
    if (queryParams.has("subcategory")) {
      queryParams.delete("subcategory");
    }

    if (queryParams.has("category")) {
      queryParams.delete("category");
    }

    history.replace({
      search: queryParams.toString() + "&category=" + e.target.value,
    });
  };

  const populateSubcategory = async (topcatid) => {
    try {
      if (topcatid) {
        const response = await axios.get(
          process.env.REACT_APP_REACT_APP_API_END_POINT +
          process.env.REACT_APP_GET_CATEGORY +
          webLanguage +
          "/" +
          topcatid +
          "?code=" +
          process.env.REACT_APP_API_KEY
        );
        if(topcatid == 17 || topcatid == 18)
        {
          setReadMoreTopic(1)
        }
        else{
          setReadMoreTopic(0)
        }
        //console.log(response.data[0].subcategory);
        setSubcategorydropdown(
          response.data[0].subcategory.sort(function (a, b) {
            return a.SubCategory > b.SubCategory ? 1 : -1;
          })
        );
        setSubcategoryID(0);
        setTopcategoryID(topcatid);
        //e.target.parentElement.classList.remove("unselected");
        dispatch(ramactions.updateCategory(topcatid));
        dispatch(ramactions.updatesubCategory(0));
        if (parseInt(subCategoryId) > 0) {
          const selectedSubCategory = response.data[0].subcategory.filter(
            (index) => index.SubCategoryID === subCategoryId
          );
          dispatch(
            ramactions.updatesubCategoryName(selectedSubCategory[0].SubCategory)
          );
          //console.log(selectedSubCategory);
        }
      } else {
        setSubcategorydropdown([]);
        setTopcategoryID(0);
        //e.target.parentElement.classList.add("unselected");
        dispatch(ramactions.updateCategory(0));
        dispatch(ramactions.updatesubCategory(0));
      }
    } catch (err) {
      //console.log(err);
      dispatch(ramactions.updateErrormsg(err));
      dispatch(ramactions.updateErrorstatus(1));
    }
  };

  const subcategoryHanddler = async (e) => {
    if (queryParams.has("resourceType")) {
      queryParams.delete("resourceType");
    }
    if (queryParams.has("languages")) {
      queryParams.delete("languages");
    }
    if (queryParams.has("communities")) {
      queryParams.delete("communities");
    }
    if (queryParams.has("accessibilities")) {
      queryParams.delete("accessibilities");
    }
    if (queryParams.has("costs")) {
      queryParams.delete("costs");
    }
    const elementIndex = e.nativeEvent.target.selectedIndex;
    dispatch(
      ramactions.updatesubCategoryName(e.nativeEvent.target[elementIndex].text)
    );
    //await populateDropdownData(e.target.value);
    setSubcategoryID(e.target.value);
    dispatch(ramactions.updatesubCategory(e.target.value));
    if (e.target.value) e.target.parentElement.classList.remove("unselected");
    else e.target.parentElement.classList.add("unselected");
    if (queryParams.has("subcategory")) {
      queryParams.delete("subcategory");
    }
    history.replace({
      search: queryParams.toString() + "&subcategory=" + e.target.value,
    });
  };

  const populateDropdownData = async (subcatid, clear = 2) => {
    setSubcategoryID(0);
    let langParams;
    let communitiesParams;
    let accessibilityParams;
    let costParams;
    let resourceTypeParams;

    if (clear === 5) {
      langParams = "any";
      communitiesParams = "any";
      accessibilityParams = "any";
      costParams = "any";
      resourceTypeParams = "hotline,physical";
    } else {
      langParams = customquery.langParams;
      communitiesParams = customquery.communitiesParams;
      accessibilityParams = customquery.accessibilityParams;
      costParams = customquery.costParams;
      resourceTypeParams = customquery.resourceTypeParams;
    }

    if (subcatid) {
      try {
        const response = await axios.get(
          process.env.REACT_APP_REACT_APP_API_END_POINT +
          process.env.REACT_APP_GET_DROPDOWN_VALUE +
          webLanguage +
          "/" +
          subcatid +
          "/" +
          resourceTypeParams +
          "/" +
          place.latitude +
          "/" +
          place.longitude +
          "/" +
          langParams +
          "/" +
          communitiesParams +
          "/" +
          accessibilityParams +
          "/" +
          costParams +
          "?code=" +
          process.env.REACT_APP_API_KEY
        );
        console.log(
          process.env.REACT_APP_REACT_APP_API_END_POINT +
          process.env.REACT_APP_GET_DROPDOWN_VALUE +
          webLanguage +
          "/" +
          subcatid +
          "/" +
          resourceTypeParams +
          "/" +
          place.latitude +
          "/" +
          place.longitude +
          "/" +
          langParams +
          "/" +
          communitiesParams +
          "/" +
          accessibilityParams +
          "/" +
          costParams +
          "?code=" +
          process.env.REACT_APP_API_KEY
        );
        setLanguagesOfferedDropdown(response.data.LanguagesOfferedDropdown);
        setTargetPopulationDropdown(response.data.TargetPopulationDropdown);
        setDisabilitiesAccessDropdown(response.data.DisabilitiesAccessDropdown);
        setFeeStructureDropdown(response.data.FeeStructureDropdown);
        setSubcategoryID(subcatid);
        dispatch(ramactions.updatesubCategory(subcatid));
      } catch (err) {
        console.log(err);
        dispatch(ramactions.updateErrormsg(err));
        dispatch(ramactions.updateErrorstatus(1));
      }
    } else {
      setLanguagesOfferedDropdown([]);
      setTargetPopulationDropdown([]);
      setDisabilitiesAccessDropdown([]);
      setFeeStructureDropdown([]);
      dispatch(ramactions.updatesubCategory(0));
    }
  };

  const dropdownchangehanddler = (clear) => {
    //console.log(clear);
    //console.log("Hiiiiii");
    populateDropdownData(subcategoryID, clear);
    /*if (updatedobj) {
      setLanguagesOfferedDropdown(updatedobj.LanguagesOfferedDropdown);
      setTargetPopulationDropdown(updatedobj.TargetPopulationDropdown);
      setDisabilitiesAccessDropdown(updatedobj.DisabilitiesAccessDropdown);
      setFeeStructureDropdown(updatedobj.FeeStructureDropdown);
    } else {
      setLanguagesOfferedDropdown([]);
      setTargetPopulationDropdown([]);
      setDisabilitiesAccessDropdown([]);
      setFeeStructureDropdown([]);
    }*/
  };

  const diplayServices = async () => {
    // const url = document.URL;
    // const lagChanger = document.querySelector('.link-lang').getAttribute('href');
    // document.querySelector('.link-lang').setAttribute('href', lagChanger + url.slice(url.indexOf('?')));
    if (isApicallneeded) {
      if (!queryParams.has("resourceType"))
        dispatch(ramactions.updateResourceType(["any"]));
      if (!queryParams.has("languages"))
        dispatch(ramactions.updateLanguages(["any"]));
      if (!queryParams.has("communities"))
        dispatch(ramactions.updateCommunities(["any"]));
      if (!queryParams.has("accessibilities"))
        dispatch(ramactions.updateAccessibility(["any"]));
      if (!queryParams.has("costs")) dispatch(ramactions.updateCost(["any"]));
      setDisplaysearchresult(true);
      props.onChangesupporttype(true);
      dispatch(ramactions.toogleSeachresultdisplay(true));
      dispatch(ramactions.changePogress(true));
      await populateDropdownData(subCategoryId);
      window.scrollTo(0, 0);
    } else {
      dispatch(ramactions.updateApiCall(true));
    }

  };

  const clearallfilter = () => {
    setIsClearClick(true);
    setTimeout(() => {
      setIsClearClick(false);
    }, 1000);
  };

  return (
    <Fragment>
      {!isDisplayresult && (
        <div className="container">
          <div className="row">
            <div className="col-xl-4 offset-xl-4 col-lg-6 offset-lg-3 col-md-8 offset-md-2">
              <Fragment>
                <div className="form-group  animate__animated animate__fadeInUp">
                  <label className="label" for="select_topic">
                    {t("dropdown_label")}
                  </label>
                  <span className="select-dropdown unselected">
                    <select onChange={topcategoryHanddler} id="select_topic">
                      <option value="">{t("dropdown_default_value")}</option>
                      {categorydropdown.map((index) => (
                        <option
                          value={index.TopCategoryID}
                          selected={
                            parseInt(index.TopCategoryID) ===
                              parseInt(topcategoryID)
                              ? "seletcted"
                              : ""
                          }
                        >
                          {index.TopCategory}
                        </option>
                      ))}
                    </select>
                    <span className="down-arrow" aria-hidden="true"></span>
                  </span>
                  {ReadMoreTopic?<span><a target="_blank" href={t("read_more_topic_link")} className="ext-link">{t("read_more_topic_text")}</a></span> : ''}
                </div>
                {subcategorydropdown.length > 0 && (
                  <div className="form-group animate__animated animate__fadeInUp">
                    <label className="label" for="subtopic">
                      {t("narrow_down__dropdown_label")}
                    </label>
                    <span className="select-dropdown unselected">
                      <select onChange={subcategoryHanddler} id="subtopic">
                        <option value="">
                          {t("narrow_down__dropdown_default_value")}
                        </option>
                        {subcategorydropdown.map((index1) => (
                          <option
                            value={index1.SubCategoryID}
                            selected={
                              parseInt(index1.SubCategoryID) ===
                                parseInt(subcategoryID)
                                ? "seletcted"
                                : ""
                            }
                          >
                            {index1.SubCategory}
                          </option>
                        ))}
                      </select>
                      <span className="down-arrow" aria-hidden="true"></span>
                    </span>
                  </div>
                )}

                {subcategoryID > 0 && place.formatted_address !== undefined &&  (
                  <div className="find__resources animate__animated animate__fadeInUp">
                    <button
                      onClick={diplayServices}
                      className="btn btn-large btn-secondary find_search-btn"
                    >
                      {t("submit_button")}
                    </button>
                  </div>
                )}
              </Fragment>
            </div>
          </div>
        </div>
      )}
      {isDisplayresult && (
        <div className="container-fluid container-fluid--1480">
          <div className="row">
            <div className="col">
              <div className="ram-search-result search_list">
                <SearchPageHeader goBackHome={props.backToHome} />
                <Dropdowns
                  languagesOfferedDropdown={languagesOfferedDropdown}
                  targetPopulationDropdown={targetPopulationDropdown}
                  disabilitiesAccessDropdown={disabilitiesAccessDropdown}
                  feeStructureDropdown={feeStructureDropdown}
                  subcategoryID={subcategoryID}
                  onDropdownchange={dropdownchangehanddler}
                  isClearClick={isClearClick}
                />
                <Searchresult
                  searchresults={searchresults}
                  clearallfilter={clearallfilter}
                />
              </div>
            </div>
          </div>
        </div>
      )}
    </Fragment>
  );
};

export default Supporttype;
